import { render, staticRenderFns } from "./PartCkuPrvsPopupMTable.vue?vue&type=template&id=154668b8&"
import script from "./PartCkuPrvsPopupMTable.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsPopupMTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports